<template>
  <div class="sub-asset-item is-flex align-center justify-between" :class="{'is-staged' : isStaged}">
    <div class="is-flex align-center justify-between">
      <icon icon="building" class="is-size-6 grab-cursor"/>
      <div class="is-flex align-center">
        <p class="has-tooltip sub-asset-item-text"
           :class="{'assigned' : !isAvailableItems}"
           :data-tooltip="`${Naming.Site}: ${site.name}`">
          {{ site.name }}
          <span v-if="isStaged === true" class="new-tag"
          >Removed</span>
        </p>
        <p v-if="!isAvailableItems"
           class="has-tooltip sub-asset-item-text assigned is-capitalized"
           :data-tooltip="`${Naming.Client}: ${site.client}`">
          <icon class="is-inline is-size-7" icon="address-book"/>
          {{ site.client }}
        </p>
        <p v-if="isAvailableItems"
           class="ml-1 has-tooltip sub-asset-item-text"
           :data-tooltip="`${Naming.Site} Creation Date`">
          <icon class=" is-inline is-size-7" icon="calendar"/>
          {{ site.created_at | date('Y-MM-DD') }}
        </p>
        <p v-if="isAvailableItems"
           class="ml-1 has-tooltip sub-asset-item-text is-capitalized"
           :data-tooltip="`${Naming.Client}`">
          <icon class=" is-inline is-size-7" icon="address-book"/>
          {{ site.client ?? site.company }}
        </p>
      </div>
    </div>
    <icon @click="pushToSelected" v-if="isAvailableItems === true"
          class="is-size-5 pl-1 pr-1 hover-highlight-success" icon="plus-circle"/>
    <icon @click="removeFromSelected" v-if="isAvailableItems === false" class="is-size-5 pl-1 pr-1 hover-highlight-danger"
          icon="times-circle"/>
  </div>
</template>

<script>
export default {
  name: 'site-item',

  props: {
    site: {
      type: Object,
    },
    isAvailableItems: {
      type: Boolean,
      default: false
    },
    staged: {
      type: Array
    }
  },

  methods: {
    pushToSelected() {
      this.$emit('pushToSelected', this.site)
    },
    removeFromSelected() {
      this.$emit('removeFromSelected', this.site)
    },
  },

  computed: {
    isStaged(){
      return this.staged?.includes(this.site)
    }
  }
}
</script>